module.exports = __webpack_public_path__ + "8b014161095e8ad11a549f365e5eb63a.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/lankenau02.jpg
// module id = 517
// module chunks = 0